import { render, staticRenderFns } from "./ycDevice.vue?vue&type=template&id=50f3422f&scoped=true&"
import script from "./ycDevice.vue?vue&type=script&lang=js&"
export * from "./ycDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f3422f",
  null
  
)

export default component.exports